import { cn } from "@/lib/utils";

interface PageBannerProps {
  title: string;
  subtitle: string;
  className?: string;
}

/**
 * Animated page header banner with gradient background and shimmer effect.
 * Used across Mapping, History, Known Mappings, and Analytics pages.
 */
export function PageBanner({ title, subtitle, className }: PageBannerProps) {
  return (
    <div
      className={cn(
        "relative w-full h-44 rounded-xl overflow-hidden mb-8 bg-[#263436] banner-shimmer animate-fade-in",
        className
      )}
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 opacity-20 bg-gradient-to-br from-[var(--color-brand-primary)]/30 to-transparent" />

      {/* Floating orb decoration */}
      <div
        className="absolute -right-12 -top-12 w-48 h-48 rounded-full opacity-[0.06] gradient-pulse"
        style={{
          background: "radial-gradient(circle, var(--color-brand-primary) 0%, transparent 70%)",
        }}
      />

      {/* Content */}
      <div className="relative z-10 p-8">
        <h1
          className="text-4xl text-white animate-fade-in-up"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {title}
        </h1>
        <p className="text-sm text-[var(--color-brand-primary)] mt-2 uppercase tracking-widest font-medium animate-fade-in-up stagger-2">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
